<template>
    <DsTable theme="dark">
        <DsTableRow v-if="showHeader">
            <DsTableCell type="th">Kombinace</DsTableCell>
            <DsTableCell type="th">Výhra</DsTableCell>
        </DsTableRow>
        <DsTableRow>
            <DsTableCell>
                <WebpImage :src="rowOneImage" alt="" css-class="bonusomat-win-table__table-img" />
            </DsTableCell>
            <DsTableCell>{{ rowOneText }}</DsTableCell>
        </DsTableRow>
        <DsTableRow>
            <DsTableCell>
                <WebpImage :src="rowTwoImage" alt="" css-class="bonusomat-win-table__table-img" />
            </DsTableCell>
            <DsTableCell>{{ rowTwoText }}</DsTableCell>
        </DsTableRow>
        <DsTableRow>
            <DsTableCell>
                <WebpImage :src="rowThreeImage" alt="" css-class="bonusomat-win-table__table-img" />
            </DsTableCell>
            <DsTableCell>{{ rowThreeText }}</DsTableCell>
        </DsTableRow>
    </DsTable>
</template>

<script lang="ts" setup>
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";

defineProps<{
    showHeader: boolean;
    rowOneText: string;
    rowOneImage: string;
    rowTwoText: string;
    rowTwoImage: string;
    rowThreeText: string;
    rowThreeImage: string;
}>();
</script>
